// extracted by mini-css-extract-plugin
export default {"pixelInput":"FacebookAssetSelect_pixelInput__aEb9N"};